import moment from 'moment';
import request from './base';
import {excludeObjNullValue, momentDatetime} from 'utils/common';

/**
 * classroom endpoints
 */
export const fetchClassrooms = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/classrooms', q, page, perPage, sortOpts, extraParams);

export const fetchClassroom = (classroomId) => request.fetchDetail(`/classrooms/${classroomId}`);

export const createClassroom = (payload) =>
  request.postJSON('/classrooms', {
    name: payload.name,
    school_id: payload.schoolId,
    level: payload.level,
    student_set_reading_period: payload.studentSetReadingPeriod.value,
  });

export const updateClassroom = (payload) =>
  request.putJSON(`/classrooms/${payload.classroomId}`, {
    name: payload.name,
    level: payload.level,
    student_set_reading_period: payload.studentSetReadingPeriod.value,
  });

export const deleteClassroom = (classroomId) => request.deleteReq(`/classrooms/${classroomId}`);

export const addUsersToClassroom = (payload) =>
  request.postJSON(
    `/classrooms/${payload.classroomId}/users`,
    excludeObjNullValue({
      user_ids: payload.userIds,
    }),
  );

export const removeUserFromClassroom = (classroomId, userId) =>
  request.deleteReq(`/classrooms/${classroomId}/users/${userId}`);

export const addExistingUserToClassrooms = (payload) =>
  request.postJSON(
    `/users/${payload.userId}/classrooms`,
    excludeObjNullValue({
      classroom_ids: payload.classroomIds,
    }),
  );

export const fetchClassroomReaders = (classroomId, q, page, perPage, sortOpts, extraParams = {}) =>
  request.fetchList(`/classrooms/${classroomId}/readers`, q, page, perPage, sortOpts, {
    ...extraParams,
    datetimeNow: encodeURIComponent(moment().toJSON()),
  });

export const fetchAllClassroomReadersWithStats = (classroomId, sortOpts, extraParams = {}) =>
  request.fetchAll({
    url: `/classrooms/${classroomId}/readers`,
    sortOpts,
    extraParams: {
      ...extraParams,
      datetimeNow: encodeURIComponent(moment().toJSON()),
    },
  });

export const fetchAllClassroomReaders = (classroomId) => request.getJSON(`/classrooms/${classroomId}/all-readers`);

export const importStudentsToClassroom = (payload) =>
  request.postJSON(
    `/classrooms/${payload.classroomId}/import-users`,
    excludeObjNullValue({
      user_ids: Array.from(payload.userIds),
    }),
  );

export const fetchAllUserClassrooms = (userId) => request.getJSON(`/users/${userId}/classrooms/all`);

export const fetchAllClassroomsForUserToMoveTo = (userId) => request.getJSON(`/users/${userId}/classrooms/to-move-to`);

export const moveUserToAnotherClassroom = (userId, payload) =>
  request.putJSON(
    `/users/${userId}/classrooms/move`,
    excludeObjNullValue({
      from_classroom_id: payload.fromClassroomId,
      to_classroom_id: payload.toClassroomId,
    }),
  );

export const unarchiveClassroom = (classroomId) => request.putJSON(`/classrooms/${classroomId}/unarchive`);

export const fetchClassroomStudentReadingNights = (classroomId, {q, page, perPage, sortOpts, extraParams}, signal) =>
  request.fetchListEnhanced(
    {url: `/classrooms/${classroomId}/students-reading-nights`, q, page, perPage, sortOpts, extraParams},
    signal,
  );

export const updateClassroomStudentReadingNights = (classroomId, userId, payload) =>
  request.putJSON(
    `/classrooms/${classroomId}/set-students-reading-nights`,
    excludeObjNullValue({
      reader_id: userId,
      base_reading_nights: parseInt(payload.baseReadingNights),
    }),
  );
